<ion-header class="ion-no-border">
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="onboarding"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button size="small" color="primary" role="link" (click)="skip()">
        {{ 'onboarding.step.skip' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="app" slot="fixed">
  <div class="app__content onboarding">
    <app-loader [full]="true" [loading]="loading"></app-loader>
    <div class="onboarding__content" *ngIf="!loading">
      <h1>{{ 'onboarding.notifications.title' | translate }}</h1>
      <p>{{ 'onboarding.notifications.desc' | translate }}</p>
      <img src="/assets/images/notifications.png" />
      <button
        [disabled]="enabling"
        class="onboarding__content__button"
        (click)="allowPush()"
      >
        <span>{{ 'onboarding.notifications.allow' | translate }}</span>
        <app-loader [loading]="enabling" color="light"></app-loader>
      </button>
    </div>
  </div>
</ion-content>
